<template lang="html">
    <vs-popup :background-color-popup="type"
              :title="title"
              :active.sync="isActive"
              :fullscreen="fullscreen">

        <div v-html="content">

        </div>

        <vs-row vs-align="center"
                vs-type="flex" vs-justify="space-around">
            <vs-icon :icon="getIcon"
                     :color="type"
                     v-if="showIcon"
                     size="large"></vs-icon>
        </vs-row>
    </vs-popup>
</template>

<script>
    export default {
        props: {
            fullscreen: {
                default: false,
                type: Boolean
            }
        },
        data() {
            return {
                isActive: false,
                defaultTitle: "",
                defaultType: "primary", // primary, success, danger, warning, dark, RGB, HEX
                defaultContent: "",
                content: "",
                title: "",
                type: "",
                showIcon: true
            }
        },
        computed: {
            getIcon: function () {
                if (this.type === 'success') {
                    return 'done';
                }

                if (this.type === 'danger') {
                    return 'error';
                }

                if (this.type === 'warning') {
                    return 'warning';
                }

                if (this.type === 'primary') {
                    return 'done';
                }

                return '';
            }
        },
        methods: {
            show: function (type, title, content, showIcon) {
                if (type) {
                    this.type = type;
                } else {
                    this.type = this.defaultType;
                }

                if (title) {
                    this.title = title;
                } else {
                    this.title = this.defaultTitle;
                }

                if (content) {
                    this.content = content;
                } else {
                    this.content = this.defaultContent;
                }

                this.showIcon = showIcon;
                this.isActive = true;
            }
        }
    }
</script>
